import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./style.css";
import { AuthContext, useAuth } from "../../authContext";
import styled from 'styled-components';

const Container = styled.div`
 display: flex;
 width: 100vw;
 padding-top: 8rem;
 flex-direction: column;
 align-items: center;
 justify-content: center;
`;

const Card = styled.div`
 width: 100%;
 max-width: 450px;
 background: white;
 border-radius: 8px;
 box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
`;

const CardHeader = styled.div`
 padding: 24px;
 text-align: center;
`;

const CardTitle = styled.h2`
 font-size: 24px;
 font-weight: 600;
 margin-bottom: 8px;
`;

const CardDescription = styled.p`
 color: #666;
 font-size: 14px;
`;


const Form = styled.form`
 padding: 24px;
 display: flex;
 flex-direction: column;
 gap: 16px;
`;

const InputGroup = styled.div`
 display: flex;
 flex-direction: column;
 gap: 8px;
`;

const Label = styled.label`
 font-size: 14px;
 font-weight: 500;
`;

const Input = styled.input`
 padding: 8px;
 border: 1px solid #e2e8f0;
 border-radius: 6px;
 width: calc(100% - 16px);
`;

const Select = styled.select`
 padding: 8px;
 border: 1px solid #e2e8f0;
 border-radius: 6px;
 width: 100%;
`;

const RadioGroup = styled.div`
 display: flex;
 gap: 16px;
 align-items: center;
`;

const RadioLabel = styled.label`
 display: flex;
 align-items: center;
 gap: 4px;
 cursor: pointer;
`;

const BirthGroup = styled.div`
 display: grid;
 grid-template-columns: repeat(3, 1fr);
 gap: 8px;
`;

const Button = styled.button`
 width: 100%;
 padding: 8px;
 background: #000;
 color: white;
 border: none;
 border-radius: 6px;
 cursor: pointer;
 font-weight: 500;
 
 &:disabled {
   opacity: 0.7;
 }
`;

function RegisterForm() {
   const [username, setUsername] = useState("");
   const [registerId, setRegisterId] = useState("");
   const [password, setPassword] = useState("");
   const [confirmPassword, setConfirmPassword] = useState("");
   const [gender, setGender] = useState("");
   const [birthYear, setBirthYear] = useState("");
   const [birthMonth, setBirthMonth] = useState("");
   const [birthDay, setBirthDay] = useState("");
   const [email, setEmail] = useState("");
   const [phone, setPhone] = useState("");
   const [alias, setAlias] = useState("");
   const [message, setMessage] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const navigate = useNavigate();

   const validateForm = () => {
       if (registerId.length === 0) {
           setMessage("아이디를 입력해주세요.");
           return false;
       }
       if (username.length === 0) {
           setMessage("이름을 입력해주세요.");
           return false;
       }
       if (password.length === 0) {
           setMessage("비밀번호를 입력해주세요.");
           return false;
       }
       if (password !== confirmPassword) {
           setMessage("비밀번호가 일치하지 않습니다.");
           return false;
       }
       return true;
   };

   const handleSubmitRegister = async (event) => {
       event.preventDefault();
       if (!validateForm()) return;

       setIsLoading(true);
       try {
           const response = await fetch('/api/register', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({
                   user_id: registerId,
                   user_name: username,
                   user_pwd: password,
                   gender: gender,
                   birth_y: birthYear,
                   birth_m: birthMonth,
                   birth_d: birthDay,
                   email: email,
                   phone: phone,
                   alias: alias
               })
           });

           if (!response.ok) throw new Error(response.statusText);
           
           alert(`${username}님, 회원가입이 성공적으로 완료되었습니다.`);
           navigate('/login');
       } catch (error) {
           console.error("회원가입 실패: ", error);
           setMessage("회원가입에 실패하였습니다.");
       } finally {
           setIsLoading(false);
       }
   };

   return (
       <Container>
           <Card>
               <CardHeader>
                   <CardTitle>회원가입</CardTitle>
                   <CardDescription>AntsNest에 오신 것을 환영합니다</CardDescription>
               </CardHeader>
               <Form onSubmit={handleSubmitRegister}>
                   {message && <p style={{color: 'red', textAlign: 'center'}}>{message}</p>}
                   
                   <InputGroup>
                       <Label htmlFor="registerId">아이디</Label>
                       <Input
                           id="registerId"
                           type="text"
                           value={registerId}
                           onChange={(e) => setRegisterId(e.target.value)}
                           required
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="username">이름</Label>
                       <Input
                           id="username"
                           type="text"
                           value={username}
                           onChange={(e) => setUsername(e.target.value)}
                           required
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="alias">별칭</Label>
                       <Input
                           id="alias"
                           type="text"
                           value={alias}
                           onChange={(e) => setAlias(e.target.value)}
                           required
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="password">비밀번호</Label>
                       <Input
                           id="password"
                           type="password"
                           value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           required
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="confirmPassword">비밀번호 확인</Label>
                       <Input
                           id="confirmPassword"
                           type="password"
                           value={confirmPassword}
                           onChange={(e) => setConfirmPassword(e.target.value)}
                           required
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label>성별</Label>
                       <RadioGroup>
                           <RadioLabel>
                               <input
                                   type="radio"
                                   name="gender"
                                   value="1"
                                   checked={gender === '1'}
                                   onChange={(e) => setGender(e.target.value)}
                               />
                               남성
                           </RadioLabel>
                           <RadioLabel>
                               <input
                                   type="radio"
                                   name="gender"
                                   value="2"
                                   checked={gender === '2'}
                                   onChange={(e) => setGender(e.target.value)}
                               />
                               여성
                           </RadioLabel>
                       </RadioGroup>
                   </InputGroup>

                   <InputGroup>
                       <Label>생년월일</Label>
                       <BirthGroup>
                           <Input
                               type="text"
                               placeholder="YYYY"
                               value={birthYear}
                               onChange={(e) => setBirthYear(e.target.value)}
                           />
                           <Select
                               value={birthMonth}
                               onChange={(e) => setBirthMonth(e.target.value)}
                           >
                               <option value="">월 선택</option>
                               {Array.from({ length: 12 }, (_, i) => {
                                   const month = (i + 1).toString().padStart(2, '0');
                                   return (
                                       <option key={month} value={month}>
                                           {month}월
                                       </option>
                                   );
                               })}
                           </Select>
                           <Input
                               type="text"
                               placeholder="DD"
                               value={birthDay}
                               onChange={(e) => setBirthDay(e.target.value)}
                           />
                       </BirthGroup>
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="email">이메일</Label>
                       <Input
                           id="email"
                           type="email"
                           value={email}
                           onChange={(e) => setEmail(e.target.value)}
                       />
                   </InputGroup>

                   <InputGroup>
                       <Label htmlFor="phone">전화번호</Label>
                       <Input
                           id="phone"
                           type="text"
                           value={phone}
                           onChange={(e) => setPhone(e.target.value)}
                       />
                   </InputGroup>

                   <Button type="submit" disabled={isLoading}>
                       {isLoading ? "가입 중..." : "회원가입"}
                   </Button>
                   
                   <Link to="/login" style={{textAlign: 'center', color: '#666', textDecoration: 'none'}}>
                       이미 계정이 있으신가요? 로그인
                   </Link>
               </Form>
           </Card>
       </Container>
   );
}

function Login() {
   const [userId, setUserId] = useState("");
   const [password, setPassword] = useState("");
   const [message, setMessage] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const navigate = useNavigate();
   const { login } = useAuth();

   const handleLoginClick = async () => {
       setIsLoading(true);
       try {
           const response = await fetch('/api/login', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ user_id: userId, user_pwd: password })
           });

           if (response.ok) {
               const userData = await response.json();
               login(userData);
               navigate('/mypage');
           } else {
               setMessage(response.status === 401 
                   ? "아이디 또는 비밀번호가 잘못되었습니다." 
                   : "로그인에 실패하였습니다. 다시 시도해주세요.");
           }
       } catch (error) {
           setMessage("로그인 요청 중 문제가 발생했습니다.");
       } finally {
           setIsLoading(false);
       }
   };

   return (
       <Container>
           <Card>
               <CardHeader>
                   <CardTitle>AntsNest</CardTitle>
                   <CardDescription>프로그래밍 강좌 마켓플레이스</CardDescription>
               </CardHeader>
               <Form onSubmit={(e) => { e.preventDefault(); handleLoginClick(); }}>
                   {message && <p style={{color: 'red', textAlign: 'center'}}>{message}</p>}
                   <InputGroup>
                       <Label htmlFor="id">아이디</Label>
                       <Input
                           id="id"
                           type="text"
                           value={userId}
                           onChange={(e) => setUserId(e.target.value)}
                           required
                       />
                   </InputGroup>
                   <InputGroup>
                       <Label htmlFor="password">비밀번호</Label>
                       <Input
                           id="password"
                           type="password"
                           value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           required
                       />
                   </InputGroup>
                   <Button type="submit" disabled={isLoading}>
                       {isLoading ? "로그인 중..." : "로그인"}
                   </Button>
                   <Link to="/Register" style={{textAlign: 'center', color: '#666', textDecoration: 'none'}}>
                       회원가입
                   </Link>
               </Form>
           </Card>
       </Container>
   );
}

export { RegisterForm, Login };